import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A stout oak: a tapered five-sided trunk under a cluster of faceted leaf blobs.
// Single-variant model (the `parts` sugar), with a gentle looping `sway` that
// rocks the canopy about the trunk top — the simplest kind of idle animation.
// Naming the leaf parts "crown" is what lets the sway track find and move them
// while the trunk stays planted.
const TRUNK = "#5a3a22";

export const oakTree = defineModel({
  id: "oak-tree",
  batchId: "standard",
  name: "Oak tree",
  tags: ["nature", "tree", "foliage", "temperate"],
  summary: "A broad deciduous oak with a faceted leaf canopy.",
  author: "age-of-mcp",
  footprint: 0.58,
  parts(): Part[] {
    const leaf = (r: number, pos: [number, number, number], color: string): Part =>
      ({ geometry: new THREE.IcosahedronGeometry(r, 0), color, position: pos, name: "crown" });
    return [
      { geometry: new THREE.CylinderGeometry(0.075, 0.12, 0.66, 5), color: TRUNK, position: [0, 0.33, 0] },
      leaf(0.5, [0, 1.04, 0], "#3e7d36"),
      leaf(0.36, [-0.32, 0.86, 0.14], "#346a2c"),
      leaf(0.34, [0.3, 1.22, -0.12], "#4f9a3d"),
      leaf(0.24, [0.04, 1.46, 0.2], "#5fb04a"),
    ];
  },
  animations: [
    {
      id: "sway",
      label: "Idle sway",
      duration: 4,
      loop: true,
      tracks: [
        {
          target: "crown",
          pivot: [0, 0.66, 0],
          rotation: [
            { t: 0, value: [0.02, 0, 0.05] },
            { t: 2, value: [-0.02, 0, -0.05], ease: "sine" },
            { t: 4, value: [0.02, 0, 0.05], ease: "sine" },
          ],
        },
      ],
    },
  ],
});
